import React from 'react'
import { ConfirmDialog } from '../../ui'

/**
 * Thin adapter that preserves the legacy `danger` prop name on top of the
 * shared <ConfirmDialog> primitive (which uses `tone="danger"`).
 */
export function TasksConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) {
  return (
    <ConfirmDialog
      open={open}
      title={title}
      message={message}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      tone={danger ? 'danger' : 'default'}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
